(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[2513],{

/***/ 79773:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/offers",
      function () {
        return __webpack_require__(91741);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 91741:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ offers; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/next/head.js
var head = __webpack_require__(9008);
var head_default = /*#__PURE__*/__webpack_require__.n(head);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./Layout/Layout.jsx + 7 modules
var Layout = __webpack_require__(24987);
// EXTERNAL MODULE: ./node_modules/next/node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(34727);
// EXTERNAL MODULE: ./node_modules/next/node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(14251);
// EXTERNAL MODULE: ./node_modules/next/node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(52875);
// EXTERNAL MODULE: ./node_modules/next/node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(69779);
// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(97582);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(94184);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./node_modules/react-infinite-scroll-component/dist/index.es.js
var index_es = __webpack_require__(58533);
// EXTERNAL MODULE: ./utils/httpClient.js
var httpClient = __webpack_require__(22550);
// EXTERNAL MODULE: ./components/OffersList/OffersList.module.scss
var OffersList_module = __webpack_require__(35789);
var OffersList_module_default = /*#__PURE__*/__webpack_require__.n(OffersList_module);
// EXTERNAL MODULE: ./node_modules/prop-types/index.js
var prop_types = __webpack_require__(45697);
// EXTERNAL MODULE: ./node_modules/lodash/cloneDeep.js
var cloneDeep = __webpack_require__(50361);
var cloneDeep_default = /*#__PURE__*/__webpack_require__.n(cloneDeep);
// EXTERNAL MODULE: ./components/index.js + 25 modules
var components = __webpack_require__(60306);
// EXTERNAL MODULE: ./node_modules/formik/dist/formik.esm.js + 112 modules
var formik_esm = __webpack_require__(28482);
// EXTERNAL MODULE: ./components/RecommendationsList/RecommendationItem/RecommendationItem.jsx
var RecommendationItem = __webpack_require__(82039);
// EXTERNAL MODULE: ./node_modules/@mui/icons-material/LocalOfferOutlined.js
var LocalOfferOutlined = __webpack_require__(11961);
// EXTERNAL MODULE: ./node_modules/@mui/icons-material/Close.js
var Close = __webpack_require__(50594);
// EXTERNAL MODULE: ./node_modules/@mui/icons-material/SortByAlpha.js
var SortByAlpha = __webpack_require__(58568);
// EXTERNAL MODULE: ./node_modules/@mui/icons-material/ArrowRightAlt.js
var ArrowRightAlt = __webpack_require__(57354);
// EXTERNAL MODULE: ./node_modules/@react-hook/window-size/dist/module/index.js + 3 modules
var dist_module = __webpack_require__(61715);
// EXTERNAL MODULE: ./node_modules/@mui/icons-material/TuneRounded.js
var TuneRounded = __webpack_require__(22734);
// EXTERNAL MODULE: ./node_modules/qs/lib/index.js
var lib = __webpack_require__(80129);
var lib_default = /*#__PURE__*/__webpack_require__.n(lib);
// EXTERNAL MODULE: ./components/AirlineAutocomplete/AirlineAutocomplete.jsx
var AirlineAutocomplete = __webpack_require__(94740);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/styles/createTheme.js + 13 modules
var createTheme = __webpack_require__(98125);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/TextField/TextField.js + 3 modules
var TextField = __webpack_require__(86005);
// EXTERNAL MODULE: ./node_modules/@material-ui/system/esm/ThemeProvider/ThemeProvider.js + 2 modules
var ThemeProvider = __webpack_require__(83587);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/utils/debounce.js + 1 modules
var debounce = __webpack_require__(19348);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/Tooltip/Tooltip.js + 3 modules
var Tooltip = __webpack_require__(68760);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/IconButton/IconButton.js + 1 modules
var IconButton = __webpack_require__(72276);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/Dialog/Dialog.js + 2 modules
var Dialog = __webpack_require__(68914);
// EXTERNAL MODULE: ./utils/usePrevious.js
var usePrevious = __webpack_require__(20569);
;// CONCATENATED MODULE: ./components/OffersList/OffersList.jsx


























var theme = (0,createTheme/* default */.Z)({
    shape: {
        borderRadius: 12
    },
    palette: {
        primary: {
            main: "#00454A"
        },
        dark: {
            main: "#0a0a0a"
        }
    },
    typography: {
        fontFamily: '"Libre Franklin", sans-serif'
    }
});
var getOfferPages = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(function(page, perPage, loadingHandler) {
        var filters, query, ref, ref1, ref2, ref3, url;
        var _arguments = arguments;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    filters = _arguments.length > 3 && _arguments[3] !== void 0 ? _arguments[3] : undefined;
                    loadingHandler(true);
                    query = (0,_object_spread/* default */.Z)({}, filters);
                    // if (filters && Object.keys(filters).length) {
                    //   query = qs.stringify(filters);
                    // }
                    if (filters && Object.keys(filters).length && filters.sort && Object.keys(filters.sort).length) {
                        ;
                        if ((ref = filters.sort) === null || ref === void 0 ? void 0 : ref.airline) {
                            ;
                            query.sort = "airline.name,".concat((ref3 = filters.sort) === null || ref3 === void 0 ? void 0 : ref3.airline);
                        }
                        if (!(filters === null || filters === void 0 ? void 0 : (ref1 = filters.sort) === null || ref1 === void 0 ? void 0 : ref1.airline) && !(filters === null || filters === void 0 ? void 0 : (ref2 = filters.sort) === null || ref2 === void 0 ? void 0 : ref2.title)) {
                            query.sort = "offercount,desc";
                        }
                    }
                    if (!filters) {
                        query.sort = "offercount,desc";
                    }
                    url = "/api/offer?page=".concat(page, "&size=").concat(perPage) + (Object.keys(query).length ? "&".concat(lib_default().stringify(query)) : "");
                    return [
                        4,
                        (0,httpClient/* httpGet */.kA)(url, true)
                    ];
                case 1:
                    return [
                        4,
                        _state.sent().json()
                    ];
                case 2:
                    return [
                        2,
                        _state.sent()
                    ];
            }
        });
    });
    return function getOfferPages(page, perPage, loadingHandler) {
        return _ref.apply(this, arguments);
    };
}();
OffersList.propTypes = {
    country: prop_types.string,
    heading: prop_types.string
};
function OffersList() {
    var getOfferItem = function getOfferItem(offerPage) {
        var ref;
        return {
            type: "Offers",
            subtype: "Offer",
            overline: "Flight Offer",
            textId: offerPage.textId,
            image: (ref = offerPage.image) === null || ref === void 0 ? void 0 : ref.substring(1),
            subtitle: offerPage.subtitle,
            title: offerPage.title,
            content: offerPage.content,
            tag: offerPage.offers ? " ".concat(offerPage.offers, "  ").concat(offerPage.offers === 1 ? "offer" : "offers", " available") : " No offers available"
        };
    };
    var defaultFilters = {
        airline: "",
        title: "",
        sort: {
            airline: null,
            title: null,
            offercount: "desc"
        }
    };
    var ref = (0,react.useState)(0), currentPage = ref[0], setCurrentPage = ref[1];
    var ref1 = (0,react.useState)([]), offers = ref1[0], setOffers = ref1[1];
    var ref2 = (0,react.useState)(false), hasMore = ref2[0], setHasMore = ref2[1];
    var ref3 = (0,react.useState)(false), loading = ref3[0], setLoading = ref3[1];
    var ref4 = (0,react.useState)(defaultFilters), filters = ref4[0], setFilters = ref4[1];
    var ref5 = (0,react.useState)(false), mobileFilters = ref5[0], setMobileFilters = ref5[1];
    var perPage = 10;
    var prevFilters = (0,usePrevious/* usePrevious */.D)({
        filters: filters
    });
    var width = (0,dist_module/* useWindowWidth */.Lm)();
    (0,react.useEffect)(function() {
        var f = validateFilters(filters);
        getOfferPages(0, perPage, setLoading, f).then(function(res) {
            setHasMore(!res.last);
            setOffers((0,_to_consumable_array/* default */.Z)(offers).concat((0,_to_consumable_array/* default */.Z)(res.content)));
            setLoading(false);
        });
    }, []);
    var renderFilters = function(param) {
        var setFieldValue = param.setFieldValue, values = param.values;
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (OffersList_module_default()).filterSmaller,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(AirlineAutocomplete/* AirlineAutocomplete */.b, {
                        name: "airline",
                        fullWidth: true,
                        value: values.airline,
                        placeholder: "Airline",
                        primaryColor: "#202020",
                        setFieldValue: setFieldValue
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (OffersList_module_default()).filterSmaller,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(TextField/* default */.Z, {
                        name: "title",
                        type: "text",
                        fullWidth: true,
                        value: values.title,
                        placeholder: "Search by title",
                        onChange: function(event) {
                            setFieldValue("title", event.target.value);
                        }
                    })
                })
            ]
        });
    };
    var validateFilters = function(f) {
        var ref;
        var filters = cloneDeep_default()(f);
        if (((ref = filters.sort) === null || ref === void 0 ? void 0 : ref.airline) === null) {
            delete filters.sort.airline;
        }
        if (!filters.airline) {
            delete filters.airline;
        }
        if (!filters.title) {
            delete filters.title;
        }
        if (filters.sort && !Object.keys(filters.sort).length) {
            delete filters.sort;
        }
        if (filters === null || filters === void 0 ? void 0 : filters.airline) {
            filters.airline = filters.airline.code;
        }
        return filters;
    };
    // useEffect(() => {
    //   if (JSON.stringify(defaultFilters) !== JSON.stringify(filters)) {
    //     const f = validateFilters(filters);
    //     getOfferPages(currentPage, perPage, setLoading, f).then((res) => {
    //       setHasMore(!res.last);
    //       setOffers([...offers, ...res.content]);
    //       setLoading(false);    
    //     });
    //   } else {
    //     getOfferPages(currentPage, perPage, setLoading).then((res) => {
    //       setHasMore(!res.last);
    //       setOffers([...offers, ...res.content]);
    //       setLoading(false);
    //     });
    //   }
    // }, [currentPage]);
    (0,react.useEffect)(function() {
        if (JSON.stringify(defaultFilters) !== JSON.stringify(filters) && JSON.stringify(prevFilters.filters) !== JSON.stringify(filters) && !filters.resetFilters) {
            setLoading(true);
            var f = validateFilters(filters);
            getOfferPages(currentPage, perPage, setLoading, f).then(function(res) {
                setHasMore(!res.last);
                setOffers((0,_to_consumable_array/* default */.Z)(res.content));
                setLoading(false);
            });
        }
        if (filters.resetFilters) {
            setFilters(defaultFilters);
            setCurrentPage(0);
            setOffers([]);
            var f1 = validateFilters(defaultFilters);
            getOfferPages(0, perPage, setLoading, f1).then(function(res) {
                setHasMore(!res.last);
                setOffers((0,_to_consumable_array/* default */.Z)(res.content));
                setLoading(false);
            });
        }
    }, [
        filters
    ]);
    var handlePagination = function(pageNumber) {
        if (JSON.stringify(defaultFilters) !== JSON.stringify(filters)) {
            var f = validateFilters(filters);
            getOfferPages(pageNumber, perPage, setLoading, f).then(function(res) {
                setHasMore(!res.last);
                setOffers((0,_to_consumable_array/* default */.Z)(offers).concat((0,_to_consumable_array/* default */.Z)(res.content)));
                setLoading(false);
            });
        } else {
            getOfferPages(pageNumber, perPage, setLoading).then(function(res) {
                setHasMore(!res.last);
                setOffers((0,_to_consumable_array/* default */.Z)(offers).concat((0,_to_consumable_array/* default */.Z)(res.content)));
                setLoading(false);
            });
        }
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: classnames_default()((OffersList_module_default()).headingContainer),
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* BCBreadcrumbs */.k7, {
                        className: "text-white",
                        headerText: "Offers"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("h1", {
                        className: classnames_default()((OffersList_module_default()).heading, "font-fragment text-center"),
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: classnames_default()((OffersList_module_default()).icon, "m-auto text-white"),
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(LocalOfferOutlined/* default */.Z, {})
                            }),
                            "Best flight offers"
                        ]
                    }),
                    width && /*#__PURE__*/ (0,jsx_runtime.jsx)(ThemeProvider/* default */.Z, {
                        theme: theme,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(formik_esm/* Formik */.J9, {
                            enableReinitialize: true,
                            initialValues: filters,
                            validate: (0,debounce/* default */.Z)(function(value) {
                                setFilters((0,_object_spread/* default */.Z)({}, value));
                            }, 1000),
                            children: function(param) {
                                var setFieldValue = param.setFieldValue, values = param.values, resetForm = param.resetForm;
                                var ref, ref1, ref2, ref3;
                                /*#__PURE__*/ return (0,jsx_runtime.jsxs)(formik_esm/* Form */.l0, {
                                    children: [
                                        width >= 1024 && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: (OffersList_module_default()).filtersContainer,
                                            children: [
                                                renderFilters({
                                                    setFieldValue: setFieldValue,
                                                    values: values
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Tooltip/* default */.Z, {
                                                    title: "Sort alphabetically",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(IconButton/* default */.Z, {
                                                        color: "inherit",
                                                        type: "reset",
                                                        onClick: function() {
                                                            var ref, ref1, ref2;
                                                            if (((ref = filters.sort) === null || ref === void 0 ? void 0 : ref.airline) === "desc") {
                                                                setCurrentPage(0);
                                                                setFieldValue("sort", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, filters.sort), {
                                                                    airline: "asc"
                                                                }));
                                                            }
                                                            if (((ref1 = filters.sort) === null || ref1 === void 0 ? void 0 : ref1.airline) === "asc") {
                                                                setCurrentPage(0);
                                                                setFieldValue("sort", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, filters.sort), {
                                                                    airline: null
                                                                }));
                                                            }
                                                            if (!((ref2 = filters.sort) === null || ref2 === void 0 ? void 0 : ref2.airline)) {
                                                                setCurrentPage(0);
                                                                setFieldValue("sort", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, filters.sort), {
                                                                    airline: "desc"
                                                                }));
                                                            }
                                                        },
                                                        "aria-label": "clear",
                                                        sx: {
                                                            border: "1px solid #fff",
                                                            borderRadius: "50%",
                                                            color: "#fff",
                                                            width: "56px",
                                                            marginRight: "1rem"
                                                        },
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(SortByAlpha/* default */.Z, {}),
                                                            ((ref = filters.sort) === null || ref === void 0 ? void 0 : ref.airline) === "asc" && /*#__PURE__*/ (0,jsx_runtime.jsx)(ArrowRightAlt/* default */.Z, {
                                                                sx: {
                                                                    position: "absolute",
                                                                    right: "-2px",
                                                                    transform: "rotate(90deg)"
                                                                }
                                                            }),
                                                            ((ref1 = filters.sort) === null || ref1 === void 0 ? void 0 : ref1.airline) === "desc" && /*#__PURE__*/ (0,jsx_runtime.jsx)(ArrowRightAlt/* default */.Z, {
                                                                sx: {
                                                                    position: "absolute",
                                                                    right: "-2px",
                                                                    transform: "rotate(-90deg)"
                                                                }
                                                            })
                                                        ]
                                                    })
                                                }),
                                                JSON.stringify(defaultFilters) !== JSON.stringify(filters) && /*#__PURE__*/ (0,jsx_runtime.jsx)(Tooltip/* default */.Z, {
                                                    title: "Reset filters",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(IconButton/* default */.Z, {
                                                        color: "inherit",
                                                        type: "reset",
                                                        onClick: function() {
                                                            resetForm({
                                                                values: defaultFilters
                                                            });
                                                            setFilters({
                                                                resetFilters: true
                                                            });
                                                        },
                                                        "aria-label": "clear",
                                                        sx: {
                                                            border: "1px solid #fff",
                                                            borderRadius: "50%",
                                                            color: "#fff",
                                                            width: "56px"
                                                        },
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Close/* default */.Z, {})
                                                    })
                                                })
                                            ]
                                        }),
                                        width < 1024 && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: (OffersList_module_default()).mobileFiltersWrapper,
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                    className: (OffersList_module_default()).filtersButton,
                                                    onClick: function() {
                                                        return setMobileFilters(true);
                                                    },
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(TuneRounded/* default */.Z, {
                                                            className: "mr-2"
                                                        }),
                                                        " Filters"
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Dialog/* default */.Z, {
                                                    open: mobileFilters,
                                                    fullWidth: true,
                                                    PaperProps: {
                                                        style: {
                                                            margin: 0,
                                                            width: "100%",
                                                            bottom: 0,
                                                            position: "absolute",
                                                            borderBottomLeftRadius: 0,
                                                            borderBottomRightRadius: 0
                                                        }
                                                    },
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                        className: (OffersList_module_default()).filtersContainerMobile,
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(IconButton/* default */.Z, {
                                                                color: "inherit",
                                                                onClick: function() {
                                                                    return setMobileFilters(false);
                                                                },
                                                                "aria-label": "close",
                                                                className: (OffersList_module_default()).closeMobileFilters,
                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Close/* default */.Z, {})
                                                            }),
                                                            renderFilters({
                                                                setFieldValue: setFieldValue,
                                                                values: values
                                                            })
                                                        ]
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                    className: (OffersList_module_default()).sorting,
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Tooltip/* default */.Z, {
                                                            title: "Sort alphabetically",
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(IconButton/* default */.Z, {
                                                                color: "inherit",
                                                                type: "reset",
                                                                onClick: function() {
                                                                    var ref, ref1, ref2;
                                                                    if (((ref = filters.sort) === null || ref === void 0 ? void 0 : ref.airline) === "desc") {
                                                                        setFieldValue("sort", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, filters.sort), {
                                                                            airline: "asc"
                                                                        }));
                                                                    }
                                                                    if (((ref1 = filters.sort) === null || ref1 === void 0 ? void 0 : ref1.airline) === "asc") {
                                                                        setFieldValue("sort", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, filters.sort), {
                                                                            airline: null
                                                                        }));
                                                                    }
                                                                    if (!((ref2 = filters.sort) === null || ref2 === void 0 ? void 0 : ref2.airline)) {
                                                                        setFieldValue("sort", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, filters.sort), {
                                                                            airline: "desc"
                                                                        }));
                                                                    }
                                                                },
                                                                "aria-label": "clear",
                                                                sx: {
                                                                    border: "1px solid #fff",
                                                                    borderRadius: "50%",
                                                                    color: "#fff",
                                                                    width: "42px",
                                                                    marginRight: "1.25rem"
                                                                },
                                                                children: [
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(SortByAlpha/* default */.Z, {}),
                                                                    ((ref2 = filters.sort) === null || ref2 === void 0 ? void 0 : ref2.airline) === "asc" && /*#__PURE__*/ (0,jsx_runtime.jsx)(ArrowRightAlt/* default */.Z, {
                                                                        sx: {
                                                                            position: "absolute",
                                                                            right: "-21px",
                                                                            transform: "rotate(90deg)"
                                                                        }
                                                                    }),
                                                                    ((ref3 = filters.sort) === null || ref3 === void 0 ? void 0 : ref3.airline) === "desc" && /*#__PURE__*/ (0,jsx_runtime.jsx)(ArrowRightAlt/* default */.Z, {
                                                                        sx: {
                                                                            position: "absolute",
                                                                            right: "-21px",
                                                                            transform: "rotate(-90deg)"
                                                                        }
                                                                    })
                                                                ]
                                                            })
                                                        }),
                                                        JSON.stringify(defaultFilters) !== JSON.stringify(filters) && /*#__PURE__*/ (0,jsx_runtime.jsx)(Tooltip/* default */.Z, {
                                                            title: "Reset filters",
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(IconButton/* default */.Z, {
                                                                color: "inherit",
                                                                type: "reset",
                                                                onClick: function() {
                                                                    resetForm({
                                                                        values: defaultFilters
                                                                    });
                                                                    setFilters({
                                                                        resetFilters: true
                                                                    });
                                                                },
                                                                "aria-label": "clear",
                                                                sx: {
                                                                    border: "1px solid #fff",
                                                                    borderRadius: "50%",
                                                                    color: "#fff",
                                                                    width: "42px"
                                                                },
                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Close/* default */.Z, {})
                                                            })
                                                        })
                                                    ]
                                                })
                                            ]
                                        })
                                    ]
                                });
                            }
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: classnames_default()((OffersList_module_default()).listContainer, "container"),
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* default */.Z, {
                        dataLength: offers.length,
                        next: function() {
                            setCurrentPage(currentPage + 1);
                            handlePagination(currentPage + 1);
                        },
                        hasMore: hasMore,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: (OffersList_module_default()).list,
                            children: offers.map(function(offer, index) {
                                return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: (OffersList_module_default()).recommendationItem,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(RecommendationItem/* RecommendationItem */.A, {
                                        item: getOfferItem(offer)
                                    })
                                }, index);
                            })
                        })
                    }),
                    loading && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (OffersList_module_default()).loader
                    }),
                    !loading && offers.length === 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (OffersList_module_default()).noResults,
                        children: "No offers found"
                    })
                ]
            })
        ]
    });
}

;// CONCATENATED MODULE: ./pages/offers.jsx





function TopLists() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)((head_default()), {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
                    rel: "canonical",
                    href: "".concat("https://www.first-class.com", "/cars")
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(OffersList, {
                heading: "Offers"
            })
        ]
    });
}
/* harmony default export */ var offers = ((0,Layout/* withLayout */.X)(TopLists, false));


/***/ }),

/***/ 35789:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"listContainer":"OffersList_listContainer___6eNl","headingContainer":"OffersList_headingContainer__yqcNZ","heading":"OffersList_heading__2kFgJ","icon":"OffersList_icon__ESdgB","list":"OffersList_list__ZEFb7","loader":"OffersList_loader____Q4N","pulseScaleOut":"OffersList_pulseScaleOut__xJxCI","recommendationItem":"OffersList_recommendationItem__86ktZ","filtersContainer":"OffersList_filtersContainer__wIFyo","filter":"OffersList_filter__kJ1Qn","filterSmaller":"OffersList_filterSmaller__oo32q","filtersSubmit":"OffersList_filtersSubmit__3dPxG","filtersContainerMobile":"OffersList_filtersContainerMobile__DO_2Z","closeMobileFilters":"OffersList_closeMobileFilters__8RsgZ","sortingDirectionIcon":"OffersList_sortingDirectionIcon__qJNBI","mobileFiltersWrapper":"OffersList_mobileFiltersWrapper__p8kMI","filtersButton":"OffersList_filtersButton__A6zE3","sorting":"OffersList_sorting__FFMTc","noResults":"OffersList_noResults__Szr1a"};

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [4885,4231,129,1979,7601,9125,6700,632,9780,6420,4987,9774,2888,179], function() { return __webpack_exec__(79773); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);